/*
 * TelaPersonalizzata – Configuratore v2 (interfaccia) per tela, Forex, Plexiglass e Legno.
 *
 * Il motore resta configurator-tela-approved-core.js (fabric.js): caricamento della foto,
 * trascinamento e zoom nel canvas, file finale ritagliato e aggiunta al carrello.
 * Questo file costruisce solo l'interfaccia per la tela e usa le funzioni globali del motore:
 * changeOption, changeFilter, changeScale, loadImage, handleChangeImage, addToCart, getExtras…
 *
 * Attivo per i quattro ID di prodotto instradati dalla sezione, senza opzione legacy.
 */
(function () {
  'use strict';

  var html = document.documentElement;
  if (!html.classList.contains('tp-tela-v2')) return;

  var app = document.getElementById('tv2');
  var cfgNode = document.getElementById('tv2-config');
  if (!app || !cfgNode || typeof window.changeOption !== 'function') {
    if (typeof window.tpTelaV2Fail === 'function') window.tpTelaV2Fail();
    else html.classList.add('tv2-unavailable');
    return;
  }

  var cfg = {};
  try { cfg = JSON.parse(cfgNode.textContent) || {}; } catch (error) {
    window.tpTelaV2Fail();
    return;
  }

  var params = new URLSearchParams(location.search);
  var hasImageParam = Boolean(params.get('image'));
  var sampleMode = false;
  if (!hasImageParam && !sampleMode) html.classList.remove('tv2-has-photo');
  app.hidden = false;

  /* -------------------------------------------------------------- materiale */
  // Stesso motore per i quattro prodotti da parete: cambiano testi, bordo e la resa nella stanza.
  var productId = String(params.get('product') || '').replace('gid://shopify/Product/', '');
  var MATERIALS = {
    '8061637722388': {
      key: 'tela', noun: 'la tela', short: 'tela', label: 'Tela su telaio', view3d: 'La tua foto',
      edge: { cm: 2, minPx: 12, kind: 'mirror', note: 'Bordo specchiato di 2 cm: il lato riprende la foto, il soggetto resta intero.' },
      title: 'La tua foto su tela', eyebrow: 'TELA SU TELAIO',
      lead: 'Scegli la foto e la vedi subito sulla tela. Per ogni misura ti diciamo il prezzo, quanto viene tagliata e se ha pixel a sufficienza.',
      receive: [['Tela in cotone', '280 g/m²'], ['Telaio in abete', 'profondo 2 cm, bordo specchiato'], ['Stampa latex', 'nel nostro laboratorio'], ['Gancio incluso', 'da applicare']]
    },
    '8082222022932': {
      key: 'forex', noun: 'il pannello', short: 'pannello Forex', label: 'Pannello Forex', view3d: 'La tua foto',
      edge: { cm: 1, minPx: 5, kind: 'color', color: '#F3F2EE', note: 'Pannello Forex da 10 mm con bordo bianco, pronto da appendere.' },
      title: 'La tua foto su Forex', eyebrow: 'PANNELLO FOREX',
      lead: 'Scegli la foto e la vedi subito sul pannello. Per ogni misura ti diciamo il prezzo, quanto viene tagliata e se ha pixel a sufficienza.',
      receive: [['Pannello Forex', 'spesso 10 mm'], ['Stampa UV diretta', 'finitura opaca'], ['Leggero e rigido', 'non si deforma'], ['Gancio già applicato', 'pronto da appendere']]
    },
    '8082232181012': {
      key: 'plexy', noun: 'il plexiglass', short: 'plexiglass', label: 'Plexiglass', view3d: 'La tua foto',
      edge: { cm: 0.5, minPx: 4, kind: 'glass', note: 'Plexiglass da 5 mm: la foto è stampata sul retro e resta brillante.' },
      title: 'La tua foto su plexiglass', eyebrow: 'PLEXIGLASS',
      lead: 'Scegli la foto e la vedi subito sul plexiglass. Per ogni misura ti diciamo il prezzo, quanto viene tagliata e se ha pixel a sufficienza.',
      receive: [['Plexiglass', 'spesso 5 mm'], ['Stampa UV sul retro', 'con fondo bianco'], ['Finitura lucida', 'colori brillanti'], ['Gancio già applicato', 'pronto da appendere']]
    },
    '8082220155156': {
      key: 'legno', noun: 'il pannello', short: 'pannello in legno', label: 'Pannello in legno', view3d: 'La tua foto',
      edge: { cm: 1, minPx: 5, kind: 'wood', note: 'Pannello in pioppo da 10 mm con bordo naturale.' },
      title: 'La tua foto su legno', eyebrow: 'PANNELLO IN LEGNO',
      lead: 'Scegli la foto e la vedi subito sul legno. Per ogni misura ti diciamo il prezzo, quanto viene tagliata e se ha pixel a sufficienza.',
      receive: [['Pannello in pioppo', 'spesso 10 mm'], ['Stampa UV diretta', 'sul legno'], ['Finitura naturale', 'venatura visibile'], ['Gancio già applicato', 'pronto da appendere']]
    }
  };
  var mat = MATERIALS[productId] || MATERIALS['8061637722388'];
  html.classList.add('tv2-mat-' + mat.key);

  (function fillMaterial() {
    var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var receive = document.getElementById('tv2-receive');
    if (receive) receive.innerHTML = mat.receive.map(function (r) { return '<li><strong>' + esc(r[0]) + '</strong><span>' + esc(r[1]) + '</span></li>'; }).join('');
    var data = (cfg.products || {})[productId] || null;
    var set = function (id, text) { var n = document.getElementById(id); if (n) n.textContent = text; };
    set('tv2-intro-eyebrow', mat.eyebrow + (data && data.count ? ' · ' + data.count + ' FORMATI' : ''));
    set('tv2-intro-title', mat.title);
    set('tv2-intro-lead', mat.lead);
    var fmt = function (cents) { return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(Number(cents) / 100); };
    set('tv2-intro-price', data && data.min != null ? 'da ' + fmt(data.min) + ' a ' + fmt(data.max) + ', IVA inclusa' : '');
    var editor = document.getElementById('tv2-editor');
    if (editor) editor.setAttribute('aria-label', 'Personalizza ' + mat.noun);
    set('tv2-seg-3d', mat.view3d);
    set('tv2-3d-edge-note', mat.edge.note);
    set('tv2-head-title', 'Personalizza ' + mat.noun);
    // freccia "indietro" della testata su telefono: alla pagina prodotto da cui si arriva
    var back = document.getElementById('tv2-back');
    var handles = { tela: 'stampa-foto-su-tela', forex: 'stampa-foto-su-forex', plexy: 'stampa-foto-su-plexiglass', legno: 'stampa-foto-su-legno' };
    if (back) back.setAttribute('href', '/products/' + handles[mat.key]);
  })();

  function updateSteps() {
    var has = html.classList.contains('tv2-has-photo');
    var a = document.getElementById('tv2-step-photo'); var b = document.getElementById('tv2-step-edit');
    if (!a || !b) return;
    a.classList.toggle('is-done', has); a.classList.toggle('is-current', !has);
    b.classList.toggle('is-current', has);
    if (has) { a.removeAttribute('aria-current'); b.setAttribute('aria-current', 'step'); } else { b.removeAttribute('aria-current'); a.setAttribute('aria-current', 'step'); }
    a.querySelector('span').textContent = has ? '✓' : '1';
    var step = document.getElementById('tv2-head-step');
    if (step) step.textContent = 'Passo ' + (has ? 2 : 1) + ' di 3';
  }
  updateSteps();
  if (window.MutationObserver) new MutationObserver(updateSteps).observe(html, { attributes: true, attributeFilter: ['class'] });

  /* ------------------------------------------------------------------ utilità */

  function $(id) { return document.getElementById(id); }
  function all(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function num(value) { var n = Number(value); return Number.isFinite(n) ? n : 0; }
  function money(value) {
    return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(num(value));
  }
  function cm(value) {
    var n = num(value);
    return Number.isInteger(n) ? String(n) : n.toFixed(1).replace('.', ',');
  }
  function r1(value) { return Math.round(value * 10) / 10; }
  function clamp(value, min, max) { return Math.max(min, Math.min(max, value)); }

  // Variabili del motore (let globali in configurator-tela-approved-core.js).
  function engineOptions() { try { return Array.isArray(availableOptions) ? availableOptions : []; } catch (e) { return []; } }
  function engineOption() { try { return option || null; } catch (e) { return null; } }
  function engineImage() { try { return image || null; } catch (e) { return null; } }
  function engineCanvas() { try { return canvas || null; } catch (e) { return null; } }
  function engineSlider() { try { return slider || $('slider'); } catch (e) { return $('slider'); } }
  function photo() {
    try {
      if (imgSource && imgSource.naturalWidth > 0 && imgSource.naturalHeight > 0) {
        return { w: imgSource.naturalWidth, h: imgSource.naturalHeight };
      }
    } catch (e) { /* motore non pronto */ }
    return null;
  }
  function photoReady() { return typeof window.hasReadyImage === 'function' && window.hasReadyImage(); }

  var state = {
    view: '3d',
    delivery: 'home',
    tab: null,
    cartSubtotal: 0,
    thumbReady: false,
    orientationTouched: false,
    userPicked: false
  };

  /* ------------------------------------------- 1 · sposta il motore nel nuovo layout
     Gira prima del DOMContentLoaded del motore: fabric si inizializza già nella nuova posizione. */

  var wrapper = $('canvas-container-wrapper');
  var box3d = $('tv2-3d');
  if (wrapper && box3d) {
    // il canvas del motore diventa la faccia davanti del quadro in 3D: si trascina e si zooma lì
    box3d.insertBefore(wrapper, box3d.firstChild);
  }
  html.classList.add('tv2-view-3d');
  var addButton = $('btn-add-to-card');
  var ctaSlot = $('tv2-cta-slot');
  if (addButton && ctaSlot) ctaSlot.appendChild(addButton);

  /* ------------------------------------------------------------ gruppi di formati */

  var GROUPS = [
    { id: 'r43', ratio: '4:3' },
    { id: 'r32', ratio: '3:2' },
    { id: 'r11', ratio: '1:1' },
    { id: 'pano', ratio: '2:1' },
    { id: 'xpano', ratio: '3:1' },
    { id: 'other', ratio: 'Altri' }
  ];

  function groupOf(item) {
    var a = num(item.width); var b = num(item.height);
    var r = Math.max(a, b) / Math.min(a, b);
    if (Math.abs(r - 1) < 0.02) return 'r11';
    if (Math.abs(r - 4 / 3) < 0.02) return 'r43';
    if (Math.abs(r - 1.5) < 0.02) return 'r32';
    if (r >= 1.7 && r < 2.5) return 'pano';
    if (r >= 2.5) return 'xpano';
    return 'other';
  }

  function photoAspect() {
    var p = photo();
    return p ? p.w / p.h : 4 / 3;
  }

  function cropOf(item) {
    var fa = num(item.width) / num(item.height);
    var pa = photoAspect();
    return 1 - Math.min(fa, pa) / Math.max(fa, pa);
  }

  function dpiOf(item) {
    var p = photo();
    if (!p) return 0;
    return Math.min(p.w / num(item.width), p.h / num(item.height)) * 2.54;
  }

  function quality(dpi) {
    if (dpi >= 100) return { k: 3, label: 'Ottima', color: 'ok' };
    if (dpi >= 65) return { k: 2, label: 'Buona', color: 'ok' };
    if (dpi >= 45) return { k: 1, label: 'Sufficiente', color: 'warn' };
    return { k: 0, label: 'Sconsigliata', color: 'bad' };
  }

  function sizeLabel(item) { return cm(item.width) + '×' + cm(item.height); }
  function area(item) { return num(item.width) * num(item.height); }

  /* ------------------------------------------- formato proposto dopo il caricamento */

  var originalFindRequested = window.findRequestedTelaFormatIndex;
  if (typeof originalFindRequested === 'function') {
    window.findRequestedTelaFormatIndex = function (items) {
      var requested = new URLSearchParams(location.search);
      var explicit = requested.get('variant') || requested.get('tp_format') || requested.get('format');
      if (explicit || cfg.initialFormat === 'legacy' || !photo() || !Array.isArray(items) || !items.length) {
        return originalFindRequested.apply(this, arguments);
      }
      // Il più piccolo formato disponibile con il taglio minore (di solito: nessun taglio).
      var best = -1;
      items.forEach(function (item, index) {
        if (!item.available) return;
        if (best < 0) { best = index; return; }
        var c = cropOf(item); var cb = cropOf(items[best]);
        if (c < cb - 0.005 || (Math.abs(c - cb) <= 0.005 && area(item) < area(items[best]))) best = index;
      });
      return best >= 0 ? best : originalFindRequested.apply(this, arguments);
    };
  }

  /* ------------------------------------------------------------ agganci al motore */

  function wrap(name, after) {
    var original = window[name];
    if (typeof original !== 'function') return;
    window[name] = function () {
      var result = original.apply(this, arguments);
      try { after.apply(this, arguments); } catch (error) { console.warn('[tela v2]', name, error); }
      return result;
    };
  }

  wrap('createOptions', function () { renderFormats(); });
  wrap('changeOption', function () { onOptionChanged(); });
  wrap('changeFilter', function (id) { syncEffects(id); refreshPreviewViews(); updateSummary(); });
  wrap('setPhotoRequiredState', function () {
    queueMicrotask(function () {
      if (photoReady()) onPhotoPlaced();
      updateCta();
    });
  });

  /* ------------------------------------------------------- file di stampa: più pixel */
  // Il motore crea il file sempre a 96 dpi, anche quando la foto ne ha molti di più, e sui telefoni lo
  // raddoppia (effetto retina) ingrandendo pixel che non esistono. Qui il file tiene i pixel veri della foto
  // nell'area scelta, da 96 a 200 dpi, senza raddoppio e con un tetto che i telefoni riescono a gestire.
  // Inquadratura, effetti, nome del file, caricamento e proprietà del carrello restano quelli del motore.
  var PRINT = { minDpi: 96, maxDpi: 200 };

  function printMaxArea() {
    var ua = navigator.userAgent || '';
    var ios = /iP(hone|ad|od)/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    if (ios) return 16000000;                 // limite delle immagini di Safari su iPhone e iPad (16,7 milioni di pixel)
    if (/Android|Mobile/i.test(ua)) return 24000000;
    return 40000000;
  }

  function printPlan() {
    var item = engineOption(); var img = engineImage(); var c = engineCanvas();
    if (!item || !img || !c || typeof imgSource === 'undefined' || !imgSource || !imgSource.naturalWidth || !img.width || !img.scaleX) return null;
    var cw = c.getWidth(); var ch = c.getHeight();
    if (!cw || !ch) return null;
    var wIn = num(item.width) / 2.54; var hIn = num(item.height) / 2.54;
    if (!wIn || !hIn) return null;
    var srcPerCanvasPx = imgSource.naturalWidth / (img.scaleX * img.width);
    var nativeDpi = cw * srcPerCanvasPx / wIn;
    var d = clamp(nativeDpi, PRINT.minDpi, PRINT.maxDpi);
    var maxArea = printMaxArea();
    var capped = wIn * hIn * d * d > maxArea;
    if (capped) d = Math.sqrt(maxArea / (wIn * hIn));
    var px = capped ? Math.floor : Math.round;
    return { dpi: d, nativeDpi: nativeDpi, capped: capped, w: Math.max(1, px(wIn * d)), h: Math.max(1, px(hIn * d)), cw: cw, ch: ch };
  }
  window.tv2PrintPlan = printPlan;

  // Effetti sul file finale: il motore li applica alla foto intera (con WebGL e un canvas grande quanto la foto),
  // che sui telefoni con foto da 24+ megapixel supera i limiti e può dare un file nero o vuoto.
  // Qui si applicano ai pixel del file, a strisce, con le stesse formule di fabric.
  function effectsSupported(filters) {
    return filters.every(function (f) {
      return f && (f.type === 'Grayscale' || (Array.isArray(f.matrix) && f.matrix.length === 20));
    });
  }
  function applyEffects(el, filters) {
    var ctx = el.getContext('2d');
    var W = el.width; var H = el.height; var band = 256;
    for (var y = 0; y < H; y += band) {
      var h = Math.min(band, H - y);
      var data = ctx.getImageData(0, y, W, h);
      var d = data.data;
      for (var f = 0; f < filters.length; f++) {
        var flt = filters[f];
        var i, r, g, b, v;
        if (flt.type === 'Grayscale') {
          var mode = flt.mode || 'average';
          for (i = 0; i < d.length; i += 4) {
            r = d[i]; g = d[i + 1]; b = d[i + 2];
            if (mode === 'luminosity') v = 0.21 * r + 0.72 * g + 0.07 * b;
            else if (mode === 'lightness') v = (Math.max(r, g, b) + Math.min(r, g, b)) / 2;
            else v = (r + g + b) / 3;
            d[i] = d[i + 1] = d[i + 2] = v;
          }
        } else {
          var m = flt.matrix; var colorsOnly = flt.colorsOnly !== false;
          for (i = 0; i < d.length; i += 4) {
            r = d[i]; g = d[i + 1]; b = d[i + 2]; var a = d[i + 3];
            if (colorsOnly) {
              d[i] = r * m[0] + g * m[1] + b * m[2] + m[4] * 255;
              d[i + 1] = r * m[5] + g * m[6] + b * m[7] + m[9] * 255;
              d[i + 2] = r * m[10] + g * m[11] + b * m[12] + m[14] * 255;
            } else {
              d[i] = r * m[0] + g * m[1] + b * m[2] + a * m[3] + m[4] * 255;
              d[i + 1] = r * m[5] + g * m[6] + b * m[7] + a * m[8] + m[9] * 255;
              d[i + 2] = r * m[10] + g * m[11] + b * m[12] + a * m[13] + m[14] * 255;
              d[i + 3] = r * m[15] + g * m[16] + b * m[17] + a * m[18] + m[19] * 255;
            }
          }
        }
      }
      ctx.putImageData(data, 0, y);
    }
  }

  var originalCutImage = window.cutImage;
  window.tv2EngineCutImage = originalCutImage; // quello del motore, per confronto
  if (typeof originalCutImage === 'function' && typeof window.setJpegDpi === 'function' && typeof window.presignedUrl === 'function' && window.fabric) {
    window.cutImage = function () {
      var plan = null;
      try { plan = printPlan(); } catch (error) { plan = null; }
      if (!plan || typeof window.hasReadyImage !== 'function' || !window.hasReadyImage()) return originalCutImage.apply(this, arguments);
      return new Promise(function (resolve, reject) {
        var img = engineImage();
        var htmlCanvas = document.createElement('canvas');
        htmlCanvas.width = plan.w;
        htmlCanvas.height = plan.h;
        // sfondo bianco: le parti trasparenti di un PNG altrimenti nel JPEG diventano nere
        var tmp = new fabric.StaticCanvas(htmlCanvas, { width: plan.w, height: plan.h, enableRetinaScaling: false, preserveObjectStacking: true, renderOnAddRemove: false, backgroundColor: '#FFFFFF' });
        var filters = Array.isArray(img.filters) ? img.filters.filter(Boolean) : [];
        var ownEffects = filters.length > 0 && effectsSupported(filters);
        // la foto originale è già caricata: si usa quella, senza scaricarla e decodificarla una seconda volta
        var withSource = function (done) {
          if (imgSource.complete && imgSource.naturalWidth) done(imgSource);
          else fabric.util.loadImage(imgSource.src, done, null, 'anonymous');
        };
        withSource(function (el) {
          if (!el) { tmp.dispose(); reject(new Error('Non è stato possibile leggere la fotografia originale.')); return; }
          try {
            var kx = plan.w / plan.cw; var ky = plan.h / plan.ch;
            var t = new fabric.Image(el);
            t.scaleX = img.scaleX * (img.width / imgSource.naturalWidth) * kx;
            t.scaleY = img.scaleY * (img.height / imgSource.naturalHeight) * ky;
            t.left = img.left * kx;
            t.top = img.top * ky;
            t.objectCaching = false;
            if (!ownEffects && filters.length) { t.filters = filters.slice(); t.applyFilters(); }
            tmp.add(t);
            tmp.renderAll();
            if (ownEffects) applyEffects(htmlCanvas, filters);
            var product = typeof window.getSelectedProduct === 'function' ? window.getSelectedProduct() : null;
            var name = typeof window.sanitizeFileName === 'function' ? window.sanitizeFileName(product ? product.title : 'prodotto-personalizzato') : 'stampa-foto-su-tela';
            var fmt = typeof window.formatMeasurement === 'function' ? window.formatMeasurement : function (v) { return String(v); };
            var item = engineOption();
            var fileName = name + '-' + fmt(item.width) + 'x' + fmt(item.height) + 'cm.jpg';
            htmlCanvas.toBlob(function (blob) {
              if (!blob) { tmp.dispose(); reject(new Error('Impossibile generare il file JPEG.')); return; }
              window.setJpegDpi(blob, Math.round(plan.dpi)).then(function (withDpi) {
                var file = new File([withDpi], fileName, { type: 'image/jpeg', lastModified: Date.now() });
                return window.presignedUrl(file);
              }).then(function (result) { tmp.dispose(); resolve(result); }, function (error) { tmp.dispose(); reject(error); });
            }, 'image/jpeg', 0.95);
          } catch (error) {
            tmp.dispose();
            reject(error);
          }
        });
      });
    };
  }

  /* ------------------------------------------------------------------ formati */

  var tabsNode = $('tv2-tabs');
  var cardsNode = $('tv2-cards');

  function currentIndex() {
    var items = engineOptions(); var current = engineOption();
    return current ? items.indexOf(current) : -1;
  }

  function renderFormats() {
    var items = engineOptions();
    if (!items.length || !tabsNode || !cardsNode) return;
    var current = engineOption();
    if (!state.tab && current) state.tab = groupOf(current);

    var groups = GROUPS.map(function (group) {
      var list = items.filter(function (item) { return groupOf(item) === group.id; });
      if (!list.length) return null;
      var crops = list.map(function (item) { return Math.round(cropOf(item) * 100); });
      return { id: group.id, ratio: group.ratio, list: list, min: Math.min.apply(null, crops), max: Math.max.apply(null, crops) };
    }).filter(Boolean);
    if (!groups.some(function (g) { return g.id === state.tab; })) state.tab = groups[0].id;
    var bestMin = Math.min.apply(null, groups.map(function (g) { return g.min; }));

    tabsNode.innerHTML = '';
    groups.forEach(function (group) {
      var rep = group.list[0];
      var box = Math.min(40 / num(rep.width), 26 / num(rep.height));
      var ratio = group.ratio;
      if (group.id !== 'r11' && group.id !== 'other' && num(rep.width) < num(rep.height)) ratio = ratio.split(':').reverse().join(':');
      var sub = group.max === 0 ? 'Foto intera' : (group.min === group.max ? 'taglio ' + group.min + '%' : 'taglio ' + group.min + '–' + group.max + '%');
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'tv2-tab' + (group.id === state.tab ? ' is-selected' : '');
      button.setAttribute('aria-pressed', group.id === state.tab ? 'true' : 'false');
      button.innerHTML =
        (group.min === bestMin ? '<span class="tv2-badge">Consigliato</span>' : '') +
        '<span class="tv2-tab-shape"><span class="tv2-thumb" style="width:' + r1(num(rep.width) * box) + 'px;height:' + r1(num(rep.height) * box) + 'px"></span></span>' +
        '<span class="tv2-tab-ratio">' + ratio + '</span>' +
        '<span class="tv2-tab-sub' + (group.max === 0 ? ' is-ok' : '') + '">' + sub + '</span>';
      button.addEventListener('click', function () { state.tab = group.id; renderFormats(); });
      tabsNode.appendChild(button);
    });

    var maxSide = Math.max.apply(null, items.map(function (item) { return Math.max(num(item.width), num(item.height)); }));
    var scale = (window.matchMedia('(max-width: 899px)').matches ? 70 : 84) / maxSide;
    var active = groups.filter(function (g) { return g.id === state.tab; })[0];
    cardsNode.innerHTML = '';
    active.list.slice().sort(function (a, b) { return area(a) - area(b); }).forEach(function (item) {
      var index = items.indexOf(item);
      var q = quality(dpiOf(item));
      var selected = item === current;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'tv2-card' + (selected ? ' is-selected' : '');
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.disabled = item.available === false;
      button.setAttribute('aria-label', cm(item.width) + ' per ' + cm(item.height) + ' centimetri, ' + money(item.price) + ', qualità ' + q.label.toLowerCase());
      button.innerHTML =
        '<span class="tv2-card-shape"><span class="tv2-thumb" style="width:' + r1(Math.max(8, num(item.width) * scale)) + 'px;height:' + r1(Math.max(8, num(item.height) * scale)) + 'px"></span></span>' +
        '<span class="tv2-card-row"><strong>' + sizeLabel(item) + '</strong><span>' + money(item.price) + '</span></span>' +
        (item.available === false
          ? '<span class="tv2-q">Non disponibile</span>'
          : (photo() ? '<span class="tv2-q tv2-q-' + q.color + '"><i></i>' + q.label + '</span>' : ''));
      button.addEventListener('click', function () {
        if (item === engineOption()) return;
        state.userPicked = true;
        window.changeOption(index, Boolean(photo()));
      });
      cardsNode.appendChild(button);
    });
  }

  /* ------------------------------------------------------- stato del formato scelto */

  function zoomFactor() {
    var img = engineImage();
    if (!img || !img.minScaleLimit) return 1;
    return Math.max(1, img.scaleX / img.minScaleLimit);
  }

  function updateQuality() {
    var node = $('tv2-quality');
    var item = engineOption();
    if (!node || !item || !photo()) { if (node) node.hidden = true; return; }
    var z = zoomFactor();
    var dpi = dpiOf(item) / z;
    var q = quality(dpi);
    var zoomText = z > 1.01 ? ' con zoom al ' + Math.round(z * 100) + '%' : '';
    var d = Math.round(dpi) + ' dpi' + zoomText;
    var items = engineOptions();
    var okList = function (list) {
      return list.filter(function (it) { return it.available !== false && quality(dpiOf(it)).k >= 2; })
        .sort(function (a, b) { return area(b) - area(a); });
    };
    var best = okList(items.filter(function (it) { return groupOf(it) === groupOf(item); }))[0] || okList(items)[0];
    var bestText = best ? sizeLabel(best) : '';
    var lowPixels = Math.max(photo().w, photo().h) < 2000;
    var title; var body;
    if (q.k === 3) { title = 'Qualità ottima'; body = 'La tua foto ha pixel in abbondanza per ' + sizeLabel(item) + ' cm (' + d + ').'; }
    else if (q.k === 2) { title = 'Buona qualità'; body = 'Nitida alla distanza da cui si guarda un quadro (' + d + ').'; }
    else if (q.k === 1) {
      title = 'Qualità sufficiente';
      body = 'Da vicino si noterà una leggera morbidezza (' + d + ').' + (z > 1.01 ? ' Riduci lo zoom per recuperare nitidezza.' : (bestText ? ' Per più nitidezza scegli fino a ' + bestText + '.' : ''));
    } else {
      title = 'Formato sconsigliato per questa foto';
      body = 'Pochi pixel per ' + sizeLabel(item) + ' cm (' + d + '): la stampa risulterebbe sgranata.' +
        (z > 1.01 ? ' Riduci lo zoom.' : (bestText ? ' Ti consigliamo al massimo ' + bestText + (lowPixels ? ', oppure carica il file originale.' : '.') : ''));
    }
    node.hidden = false;
    node.className = 'tv2-quality tv2-quality-' + q.color;
    node.innerHTML = '<span class="tv2-quality-icon" aria-hidden="true">' + (q.k >= 2 ? '✓' : '!') + '</span><span><strong>' + title + '</strong><span>' + body + '</span></span>';
  }

  function updatePanHint() {
    var node = $('tv2-pan-hint');
    var item = engineOption();
    if (!node || !item) return;
    var z = zoomFactor();
    var crop = Math.round(cropOf(item) * 100);
    var vertical = num(item.width) / num(item.height) > photoAspect();
    var article = (crop === 1 || crop === 11 || String(crop).charAt(0) === '8') ? 'l’' : 'il ';
    if (z > 1.01) node.textContent = 'Trascina la foto nel riquadro per scegliere cosa tenere.';
    else if (crop > 0) node.textContent = 'Questo formato taglia ' + article + crop + (vertical ? '% dell’altezza' : '% della larghezza') + ': trascina la foto per scegliere cosa tenere.';
    else node.textContent = 'La foto entra intera. Ingrandisci con lo zoom per stringere l’inquadratura.';
  }

  function updateDims() {
    var item = engineOption();
    if (!item) return;
    var w = $('tv2-dim-w'); var h = $('tv2-dim-h');
    if (w) w.textContent = cm(item.width) + ' cm';
    if (h) h.textContent = cm(item.height) + ' cm';
  }

  function updateOrientationButtons() {
    var item = engineOption();
    var land = item && num(item.width) > num(item.height);
    var port = item && num(item.width) < num(item.height);
    all('[data-tv2-orient]').forEach(function (button) {
      var on = (button.dataset.tv2Orient === 'landscape' && land) || (button.dataset.tv2Orient === 'portrait' && port);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      button.classList.toggle('is-selected', Boolean(on));
      button.disabled = item ? num(item.width) === num(item.height) : true;
    });
  }

  function rememberSelection() {
    var item = engineOption();
    if (!item || !state.userPicked || typeof window.insertUrlParam !== 'function') return;
    // Formato scelto dal cliente: se ricarica la pagina o carica la sua foto dopo l'esempio, lo ritrova.
    window.insertUrlParam('variant', String(item.id));
    if (state.orientationTouched && !sampleMode && num(item.width) !== num(item.height)) {
      window.insertUrlParam('orientation', num(item.width) > num(item.height) ? 'landscape' : 'portrait');
    }
  }

  function onOptionChanged() {
    var item = engineOption();
    if (item) state.tab = state.tab && engineOptions().some(function (it) { return groupOf(it) === state.tab && it === item; }) ? state.tab : groupOf(item);
    renderFormats();
    fitCanvas();
    updateDims();
    updateQuality();
    updatePanHint();
    updateOrientationButtons();
    updateSummary();
    rememberSelection();
  }

  /* ---------------------------------------------------------- canvas e anteprime */

  var stage = $('tv2-stage');

  function fitCanvas() {
    var item = engineOption();
    if (!wrapper || !stage || !item) return;
    var w = num(item.width); var h = num(item.height);
    if (!w || !h) return;
    wrapper.style.setProperty('--tp-canvas-ratio', w + ' / ' + h);
    var mobile = window.matchMedia('(max-width: 899px)').matches;
    var availW = Math.max(160, stage.clientWidth * (mobile ? 0.66 : 0.65));
    var availH = Math.max(140, stage.clientHeight * (mobile ? 0.66 : 0.62));
    var width = Math.min(availW, availH * (w / h));
    wrapper.style.setProperty('width', Math.round(width) + 'px', 'important');
    wrapper.style.setProperty('max-width', Math.round(width) + 'px', 'important');
    update3d();
  }

  /* ------------------------------------------------------------------ vista 3D
     Il lato del quadro: spessore in scala (2 cm per la tela, 1 cm Forex e legno, 5 mm plexiglass).
     Per la tela il lato riprende la foto specchiata (bordo specchiato), per i pannelli il colore del materiale. */
  var edgeCanvas = $('tv2-3d-edge');
  var side = $('tv2-3d-side');
  var edgeFrame = 0;

  function update3d() {
    var item = engineOption();
    if (!wrapper || !side || !item) return;
    var fw = wrapper.offsetWidth; var fh = wrapper.offsetHeight;
    var wcm = num(item.width);
    if (!fw || !fh || !wcm) return;
    var depth = Math.round(clamp(mat.edge.cm * fw / wcm, mat.edge.minPx, 34));
    side.style.width = depth + 'px';
    side.style.height = fh + 'px';
    var sizeNode = $('tv2-3d-size');
    if (sizeNode) sizeNode.textContent = cm(item.width) + '×' + cm(item.height) + ' cm · ' + (num(item.width) > num(item.height) ? 'orizzontale' : num(item.width) < num(item.height) ? 'verticale' : 'quadrato');
    drawEdge();
  }

  function drawEdge() {
    var item = engineOption();
    var c = engineCanvas();
    if (!edgeCanvas || !side || !item) return;
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var dw = Math.max(1, Math.round(side.offsetWidth * dpr));
    var dh = Math.max(1, Math.round(side.offsetHeight * dpr));
    if (edgeCanvas.width !== dw) edgeCanvas.width = dw;
    if (edgeCanvas.height !== dh) edgeCanvas.height = dh;
    var ctx = edgeCanvas.getContext('2d');
    if (!ctx) return;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, dw, dh);
    var kind = mat.edge.kind;
    if (kind === 'mirror') {
      var src = c && c.lowerCanvasEl;
      if (!src || !src.width || !photoReady()) { ctx.fillStyle = '#E9E4DC'; ctx.fillRect(0, 0, dw, dh); return; }
      // striscia destra della foto larga quanto il bordo (2 cm in scala), ribaltata: il lato "si piega" dalla faccia
      var sw = Math.max(1, Math.round(src.width * mat.edge.cm / num(item.width)));
      try {
        ctx.translate(dw, 0);
        ctx.scale(-1, 1);
        ctx.drawImage(src, src.width - sw, 0, sw, src.height, 0, 0, dw, dh);
      } catch (error) { ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.fillStyle = '#E9E4DC'; ctx.fillRect(0, 0, dw, dh); }
      return;
    }
    var g;
    if (kind === 'wood') {
      g = ctx.createLinearGradient(0, 0, dw, 0);
      g.addColorStop(0, '#D2AD7F'); g.addColorStop(0.5, '#C39A68'); g.addColorStop(1, '#B98E5B');
      ctx.fillStyle = g; ctx.fillRect(0, 0, dw, dh);
      ctx.globalAlpha = 0.18; ctx.fillStyle = '#7A5530';
      for (var y = 0; y < dh; y += Math.max(3, Math.round(7 * dpr))) ctx.fillRect(0, y, dw, Math.max(1, Math.round(dpr)));
      ctx.globalAlpha = 1;
    } else if (kind === 'glass') {
      g = ctx.createLinearGradient(0, 0, dw, 0);
      g.addColorStop(0, 'rgba(214, 232, 230, 0.95)'); g.addColorStop(0.5, 'rgba(244, 250, 249, 0.9)'); g.addColorStop(1, 'rgba(200, 222, 220, 0.95)');
      ctx.fillStyle = g; ctx.fillRect(0, 0, dw, dh);
    } else {
      ctx.fillStyle = mat.edge.color || '#F3F2EE';
      ctx.fillRect(0, 0, dw, dh);
    }
  }

  function scheduleEdge() {
    if (edgeFrame) return;
    edgeFrame = requestAnimationFrame(function () { edgeFrame = 0; drawEdge(); });
  }

  function snapshot() {
    var c = engineCanvas();
    if (!c || !photoReady()) return '';
    try {
      var multiplier = clamp(1400 / Math.max(c.getWidth(), c.getHeight()), 1, 4);
      return c.toDataURL({ format: 'jpeg', quality: 0.86, multiplier: multiplier });
    } catch (error) {
      console.warn('[tela v2] anteprima', error);
      return '';
    }
  }

  // Stanza fotografica: coordinate in pixel della foto larga 2000 px (la foto è estesa in alto e ai lati).
  // Misurato sulla foto: pavimento a y 1089, piedini posteriori del divano da x 392 a 1548 = divano di 200 cm.
  var ROOM = {
    S: 5.72,            // px per cm sul piano della parete
    xC: 970,            // centro del divano
    yF: 1089,           // linea parete-pavimento
    bottomCm: 102,      // bordo basso della tela: 22 cm sopra lo schienale
    sofa: 1156,         // larghezza del divano sul piano della parete (200 cm)
    minW: 1540,         // il divano deve stare tutto nell'inquadratura
    bottom: 1300,       // taglio basso preferito (si vede il pavimento)
    bottomMin: 960,     // per le tele molto alte si può tagliare fino alla seduta
    topCap: -150        // di norma non si mostra più di così della parete aggiunta sopra la foto
  };

  function setBox(id, x, y, w, h) {
    var node = $(id);
    if (!node) return;
    node.setAttribute('x', String(r1(x)));
    node.setAttribute('y', String(r1(y)));
    node.setAttribute('width', String(r1(w)));
    node.setAttribute('height', String(r1(h)));
  }

  function renderWall(url) {
    var item = engineOption();
    var svg = $('tv2-room');
    if (!svg || !item || !stage) return;
    var W = stage.clientWidth; var H = stage.clientHeight;
    if (!W || !H) return;
    var A = W / H;
    var w = num(item.width); var h = num(item.height);
    var pw = w * ROOM.S; var ph = h * ROOM.S;
    var y1 = ROOM.yF - ROOM.bottomCm * ROOM.S;
    var y0 = y1 - ph;
    var x0 = ROOM.xC - pw / 2;

    function frame(margin) {
      var need = y0 - margin;                   // il bordo alto visibile deve stare sopra la tela e la sua misura
      var bottom = ROOM.bottom;
      var Hv = Math.max(bottom - need, ROOM.minW / A, Math.min(2000 / A, bottom - ROOM.topCap));
      if (A * Hv > 2000) {
        // prima di mostrare la parte aggiunta ai lati, si taglia un po' di pavimento
        var b2 = Math.max(ROOM.bottomMin, need + 2000 / A);
        if (b2 < bottom) { bottom = b2; Hv = Math.max(bottom - need, ROOM.minW / A); }
      }
      var Wv = A * Hv;
      var left = ROOM.xC - Wv / 2;
      if (Wv <= 2000) left = clamp(left, 0, 2000 - Wv);
      return { left: left, top: bottom - Hv, w: Wv, h: Hv, k: W / Wv, bottom: bottom };
    }
    var f = frame(100);
    f = frame(Math.max(60, 36 / f.k));

    svg.setAttribute('viewBox', [f.left, f.top, f.w, f.h].map(function (n) { return Math.round(n * 100) / 100; }).join(' '));
    setBox('tv2r-cshadow', x0 + 10, y0 + 14, pw, ph);
    setBox('tv2r-ccontact', x0 + 2, y0 + 3, pw, ph);
    setBox('tv2r-img', x0, y0, pw, ph);
    setBox('tv2r-cshade', x0, y0, pw, ph);
    setBox('tv2r-cliprect', x0, y0, pw, ph);
    // resa del materiale: plexiglass lucido, legno che scalda i colori, forex opaco
    var shade = $('tv2r-cshade');
    if (shade) {
      shade.style.mixBlendMode = '';
      shade.removeAttribute('fill-opacity');
      if (mat.key === 'plexy') shade.setAttribute('fill', 'url(#tv2r-gloss-g)');
      else if (mat.key === 'legno') { shade.setAttribute('fill', '#C49A62'); shade.setAttribute('fill-opacity', '0.22'); shade.style.mixBlendMode = 'multiply'; }
      else if (mat.key === 'forex') { shade.setAttribute('fill', 'url(#tv2r-sheen-g)'); shade.setAttribute('fill-opacity', '0.4'); }
      else shade.setAttribute('fill', 'url(#tv2r-sheen-g)');
    }
    var img = $('tv2r-img');
    img.setAttribute('href', url);

    var px = function (x) { return (x - f.left) * f.k; };
    var py = function (y) { return (y - f.top) * f.k; };
    var dw = $('tv2-wall-w'); var dh = $('tv2-wall-h'); var sofaLabel = $('tv2-sofa-label');
    if (dw) {
      dw.textContent = cm(w) + ' cm';
      dw.style.left = r1(px(x0)) + 'px'; dw.style.width = r1(pw * f.k) + 'px'; dw.style.top = r1(py(y0) - 22) + 'px';
    }
    if (dh) {
      dh.textContent = cm(h) + ' cm';
      dh.style.left = r1(px(x0 + pw) + 8) + 'px'; dh.style.height = r1(ph * f.k) + 'px'; dh.style.top = r1(py(y0)) + 'px';
    }
    if (sofaLabel) {
      sofaLabel.style.left = r1(px(ROOM.xC)) + 'px';
      sofaLabel.style.top = r1(Math.min(py(1150), H - 20)) + 'px';
    }
    var text;
    if (w < h) text = 'I formati verticali rendono al meglio su pareti strette, accanto a una porta o in coppia.';
    else if (w < 100) text = 'Sopra un divano da 200 cm un quadro sta bene tra metà e due terzi della sua larghezza (circa 100–135 cm): prova 75×100 o 80×120.';
    else if (w <= 135) text = 'Proporzione giusta: ' + mat.noun + ' copre il ' + Math.round(w / 200 * 100) + '% della larghezza del divano.';
    else text = 'Formato importante: dà il meglio su una parete ampia e libera.';
    var note = $('tv2-wall-note'); // il consiglio sta sotto la scena, così niente copre la stanza
    if (note) note.textContent = text;
  }

  function refreshPreviewViews() {
    if (state.view !== 'wall') return;
    var url = snapshot();
    if (!url) return;
    if (state.view === 'wall') renderWall(url);
  }

  // La foto della stanza si scarica solo quando serve: dopo che il cliente ha una foto nell'editor
  // (con calma, per non rallentare il resto) o al primo clic su "Sulla parete".
  var roomLoaded = false;
  function loadRoom() {
    if (roomLoaded) return;
    roomLoaded = true;
    ['tv2r-photo', 'tv2r-light'].forEach(function (id) {
      var node = $(id);
      if (node && node.getAttribute('data-href')) node.setAttribute('href', node.getAttribute('data-href'));
    });
  }
  function loadRoomSoon() {
    if (roomLoaded) return;
    if (window.requestIdleCallback) window.requestIdleCallback(loadRoom, { timeout: 4000 });
    else setTimeout(loadRoom, 2500);
  }

  function setView(view) {
    if (view !== '3d' && view !== 'wall') view = '3d';
    if (view !== '3d' && !photoReady()) view = '3d';
    if (view === 'wall') loadRoom();
    state.view = view;
    all('[data-tv2-view]').forEach(function (button) {
      var on = button.dataset.tv2View === view;
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      button.classList.toggle('is-selected', on);
    });
    $('tv2-view-3d').hidden = view !== '3d';
    $('tv2-view-wall').hidden = view !== 'wall';
    html.classList.toggle('tv2-view-3d', view === '3d');
    html.classList.toggle('tv2-on-wall', view === 'wall');
    if (view === '3d') { fitCanvas(); var c = engineCanvas(); if (c) c.calcOffset(); }
    refreshPreviewViews();
  }

  all('[data-tv2-view]').forEach(function (button) {
    button.addEventListener('click', function () { setView(button.dataset.tv2View); });
  });

  /* --------------------------------------------------------------- zoom e centra */

  var zoomInput = $('tv2-zoom');

  function syncZoomUi() {
    var z = zoomFactor();
    if (zoomInput) zoomInput.value = String(Math.round(z * 100));
    var pct = $('tv2-zoom-pct');
    if (pct) pct.textContent = Math.round(z * 100) + '%';
    updateQuality();
    updatePanHint();
  }

  function setZoom(factor) {
    var s = engineSlider();
    var img = engineImage();
    if (!s || !img || !img.minScaleLimit) return;
    var min = num(s.min) || img.minScaleLimit;
    var max = num(s.max) || img.minScaleLimit * 2;
    s.value = String(clamp(img.minScaleLimit * factor, min, max));
    s.dispatchEvent(new Event('input', { bubbles: true })); // changeScale() del motore
    syncZoomUi();
  }

  function zoomBounds() {
    var s = engineSlider(); var img = engineImage();
    if (!s || !img || !img.minScaleLimit) return { max: 2 };
    return { max: (num(s.max) || img.minScaleLimit * 2) / img.minScaleLimit };
  }

  if (zoomInput) {
    zoomInput.addEventListener('input', function () { setZoom(num(zoomInput.value) / 100); });
  }
  all('[data-tv2-zoom]').forEach(function (button) {
    button.addEventListener('click', function () {
      setZoom(clamp(zoomFactor() + num(button.dataset.tv2Zoom) * 0.2, 1, zoomBounds().max));
    });
  });
  var recenter = $('tv2-recenter');
  if (recenter) {
    recenter.addEventListener('click', function () {
      var img = engineImage(); var c = engineCanvas();
      if (!img || !c) return;
      setZoom(1);
      c.centerObject(img);
      if (typeof window.setLimitMovingFromTarget === 'function') window.setLimitMovingFromTarget(img);
      img.setCoords();
      c.renderAll();
    });
  }

  // Entrambe le viste spostano la stessa foto del motore; la posizione del quadro nella stanza resta fissa.
  function install3dDrag() {
    var c = engineCanvas();
    if (!c) return;
    c.skipTargetFind = true; // niente doppio spostamento dove il browser passasse comunque il clic al canvas
    c.selection = false;
    ['tv2-view-3d', 'tv2-view-wall'].forEach(function (id) {
    var view = $(id);
    if (!view) return;
    var wall = id === 'tv2-view-wall';
    var drag = null; var previewFrame = 0;
    view.addEventListener('pointerdown', function (event) {
      var img = engineImage(); var cv = engineCanvas();
      if (drag || !img || !cv || !photoReady()) return;
      if (event.button !== undefined && event.button > 0) return;
      if (event.target && event.target.closest && event.target.closest('button, a, input, label')) return;
      var rect = wall ? $('tv2r-img').getBoundingClientRect() : cv.upperCanvasEl.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      if (wall && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) return;
      drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: img.left, top: img.top, kx: cv.getWidth() / rect.width, ky: cv.getHeight() / rect.height };
      try { view.setPointerCapture(event.pointerId); } catch (error) { /* facoltativo */ }
      html.classList.add('tv2-dragging', 'tv2-touched');
      event.preventDefault();
    });
    view.addEventListener('pointermove', function (event) {
      if (!drag || event.pointerId !== drag.id) return;
      var img = engineImage(); var cv = engineCanvas();
      if (!img || !cv || (img.lockMovementX && img.lockMovementY)) return; // durante il pizzico si zooma soltanto
      img.set({ left: drag.left + (event.clientX - drag.x) * drag.kx, top: drag.top + (event.clientY - drag.y) * drag.ky });
      if (typeof window.setLimitMovingFromTarget === 'function') window.setLimitMovingFromTarget(img);
      img.setCoords();
      if (wall) {
        cv.renderAll();
        if (!previewFrame) previewFrame = requestAnimationFrame(function () { previewFrame = 0; refreshPreviewViews(); });
      } else cv.requestRenderAll();
    });
    var end = function (event) {
      if (!drag || event.pointerId !== drag.id) return;
      drag = null;
      html.classList.remove('tv2-dragging');
      var img = engineImage(); var cv = engineCanvas();
      if (img && cv) cv.fire('object:modified', { target: img });
      if (wall) refreshPreviewViews();
      syncZoomUi();
    };
    view.addEventListener('pointerup', end);
    view.addEventListener('pointercancel', end);
    });
  }

  // Pizzico con due dita (telefono): cambia lo zoom senza spostare la foto.
  function installPinch() {
    var target = $('tv2-view-3d');
    if (!target) return;
    var pinch = null;
    function distance(touches) {
      var a = touches[0]; var b = touches[1];
      return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY) || 1;
    }
    target.addEventListener('touchstart', function (event) {
      var img = engineImage();
      if (event.touches.length !== 2 || !img) return;
      pinch = { d: distance(event.touches), z: zoomFactor() };
      img.lockMovementX = true; img.lockMovementY = true;
    }, { passive: true });
    target.addEventListener('touchmove', function (event) {
      if (!pinch || event.touches.length !== 2) return;
      event.preventDefault();
      setZoom(clamp(pinch.z * distance(event.touches) / pinch.d, 1, zoomBounds().max));
    }, { passive: false });
    var end = function (event) {
      if (!pinch || (event.touches && event.touches.length >= 2)) return;
      pinch = null;
      var img = engineImage();
      if (img) { img.lockMovementX = false; img.lockMovementY = false; }
    };
    target.addEventListener('touchend', end, { passive: true });
    target.addEventListener('touchcancel', end, { passive: true });
  }

  /* --------------------------------------------------------------- orientamento */

  all('[data-tv2-orient]').forEach(function (button) {
    button.addEventListener('click', function () {
      var wanted = button.dataset.tv2Orient;
      var items = engineOptions();
      var index = currentIndex();
      if (!items.length || index < 0) return;
      items.forEach(function (item) {
        var a = num(item.width); var b = num(item.height);
        var min = Math.min(a, b); var max = Math.max(a, b);
        if (wanted === 'landscape') { item.width = max; item.height = min; } else { item.width = min; item.height = max; }
      });
      state.orientationTouched = true;
      state.userPicked = true;
      window.changeOption(index, Boolean(photo()));
    });
  });

  /* -------------------------------------------------------------------- effetti */

  function syncEffects(id) {
    var checked = id || (document.querySelector('.option-filter:checked') || {}).id || 'filter-none';
    all('[data-tv2-effect]').forEach(function (button) {
      var on = button.dataset.tv2Effect === checked;
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      button.classList.toggle('is-selected', on);
    });
  }

  all('[data-tv2-effect]').forEach(function (button) {
    button.addEventListener('click', function () {
      window.changeFilter(button.dataset.tv2Effect, button.dataset.tv2Filter || '');
    });
  });

  /* ------------------------------------------------------- ritocchi (servizi extra) */

  function renderServices() {
    var box = $('tv2-services'); var list = $('tv2-services-list');
    var product = null;
    try { product = serviceExtraProduct; } catch (e) { product = null; }
    if (!box || !list || !product || !Array.isArray(product.variants) || !product.variants.length) return;
    list.innerHTML = '';
    product.variants.forEach(function (variant, index) {
      var legacy = $('extra-' + index);
      var label = document.createElement('label');
      label.className = 'tv2-check-row';
      label.innerHTML = '<input type="checkbox"><span class="tv2-grow"></span><span class="tv2-price-sm"></span>';
      var input = label.querySelector('input');
      label.querySelector('.tv2-grow').textContent = variant.title;
      label.querySelector('.tv2-price-sm').textContent = '+' + money(variant.price / 100);
      input.checked = Boolean(legacy && legacy.checked);
      input.addEventListener('change', function () {
        var target = $('extra-' + index);
        if (target) target.checked = input.checked; // getExtras() del motore legge questi campi
        updateSummary();
      });
      list.appendChild(label);
    });
    var cheapest = Math.min.apply(null, product.variants.map(function (v) { return v.price; }));
    box.dataset.from = money(cheapest / 100);
    box.hidden = false;
    updateSummary();
  }

  var servicesToggle = $('tv2-services-toggle');
  if (servicesToggle) {
    servicesToggle.addEventListener('click', function () {
      var open = servicesToggle.getAttribute('aria-expanded') !== 'true';
      servicesToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      $('tv2-services-list').hidden = !open;
    });
  }

  function extrasTotal() {
    if (typeof window.getExtras !== 'function') return { total: 0, count: 0 };
    var extras = window.getExtras();
    return { total: extras.reduce(function (sum, e) { return sum + num(e.price); }, 0), count: extras.length };
  }

  /* ------------------------------------------------------------ confezione regalo */

  function giftPrice() {
    try { return giftProduct && giftProduct.price ? giftProduct.price / 100 : 0; } catch (e) { return 0; }
  }
  function giftChecked() { var g = $('gift-box'); return Boolean(g && g.checked); }

  function setupGift() {
    var box = $('tv2-gift');
    if (!box || !cfg.giftEnabled || !giftPrice()) return;
    $('tv2-gift-price').textContent = money(giftPrice());
    box.hidden = false;
    var check = $('tv2-gift-check');
    var wrapMessage = $('tv2-gift-message-wrap');
    var message = $('tv2-gift-message');
    check.addEventListener('change', function () {
      var legacy = $('gift-box');
      if (legacy) { legacy.checked = check.checked; if (typeof window.changeGiftbox === 'function') window.changeGiftbox(); }
      wrapMessage.hidden = !check.checked;
      updateSummary();
    });
    message.addEventListener('input', function () {
      var legacyMessage = $('gift-message'); // addGiftBox() legge il testo da qui
      if (legacyMessage) legacyMessage.value = message.value;
    });
  }

  /* ----------------------------------------------- riepilogo, spedizione e consegna */

  var HOLIDAYS = ['01-01', '01-06', '04-25', '05-01', '06-02', '08-15', '11-01', '12-08', '12-25', '12-26'];
  function easterMonday(year) {
    var a = year % 19; var b = Math.floor(year / 100); var c = year % 100; var d = Math.floor(b / 4); var e = b % 4;
    var f = Math.floor((b + 8) / 25); var g = Math.floor((b - f + 1) / 3); var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4); var k = c % 4; var l = (32 + 2 * e + 2 * i - h - k) % 7; var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31); var day = ((h + l - 7 * m + 114) % 31) + 1;
    var date = new Date(year, month - 1, day + 1);
    return String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
  }
  function isWorkday(date) {
    var day = date.getDay();
    if (day === 0 || day === 6) return false;
    var key = String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
    return HOLIDAYS.indexOf(key) < 0 && key !== easterMonday(date.getFullYear());
  }
  function addWorkdays(from, days) {
    var date = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    var left = days;
    while (left > 0) { date.setDate(date.getDate() + 1); if (isWorkday(date)) left -= 1; }
    return date;
  }
  function formatDay(date) {
    return new Intl.DateTimeFormat('it-IT', { weekday: 'long', day: 'numeric', month: 'long' }).format(date);
  }

  function updateSummary() {
    var item = engineOption();
    var totalNode = $('tv2-total');
    if (!item || !totalNode) return;
    var extras = extrasTotal();
    var gift = giftChecked() ? giftPrice() : 0;
    var total = num(item.price) + extras.total + gift;
    var home = state.delivery !== 'pickup';
    var threshold = num(cfg.freeShipping) || 60;
    var inCart = state.cartSubtotal + total;
    var missing = Math.max(0, threshold - inCart);
    var ship = home && missing > 0 ? (num(cfg.shippingPrice) || 6) : 0;
    totalNode.textContent = money(total + ship);

    var parts = [mat.short + ' ' + money(item.price)];
    if (extras.total) parts.push('ritocchi ' + money(extras.total));
    if (gift) parts.push('regalo ' + money(gift));
    parts.push(home ? (ship ? 'spedizione ' + money(ship) : 'spedizione gratis') : 'ritiro gratis');
    $('tv2-breakdown').textContent = parts.join(' + ');

    var summary = $('tv2-services-summary');
    if (summary) {
      var box = $('tv2-services');
      summary.textContent = extras.count
        ? (extras.count === 1 ? '1 selezionato · ' : extras.count + ' selezionati · ') + money(extras.total)
        : 'Facoltativi' + (box && box.dataset.from ? ' · da ' + box.dataset.from : '');
    }

    $('tv2-ship-row').hidden = !home;
    $('tv2-pickup-msg').hidden = home;
    $('tv2-ship-fill').style.width = Math.round(clamp(inCart / threshold, 0, 1) * 100) + '%';
    var msg = $('tv2-ship-msg');
    msg.textContent = missing > 0
      ? 'Aggiungi ' + money(missing) + ' per la spedizione gratuita'
      : 'Spedizione gratuita inclusa';
    msg.classList.toggle('is-ok', missing <= 0);
  }

  function updateEta() {
    var node = $('tv2-eta');
    if (!node) return;
    var ready = addWorkdays(new Date(), Math.max(0, num(cfg.prepDays)) || 0);
    if (!num(cfg.prepDays) && !isWorkday(ready)) ready = addWorkdays(ready, 1);
    var arrive = addWorkdays(ready, Math.max(1, num(cfg.deliveryDays) || 3));
    var home = state.delivery !== 'pickup';
    var title = $('tv2-eta-title');
    if (title) title.textContent = home ? 'Consegna stimata' : 'Pronta per il ritiro da';
    node.textContent = formatDay(home ? arrive : ready);
  }

  /* ---------------------------------------------------- consegna: a casa o in studio
     Su computer la scelta sta nella barra in basso, su telefono tra le opzioni (come nei due progetti).
     La preferenza va anche nel carrello come attributo "Consegna preferita": il metodo si conferma al checkout. */
  var delivery = $('tv2-delivery');

  function setDelivery(value, save) {
    state.delivery = value === 'pickup' ? 'pickup' : 'home';
    all('[data-tv2-delivery]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.dataset.tv2Delivery === state.delivery ? 'true' : 'false');
    });
    updateEta();
    updateSummary();
    if (!save) return;
    try { sessionStorage.setItem('tv2-delivery', state.delivery); } catch (error) { /* facoltativo */ }
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Consegna preferita': state.delivery === 'pickup' ? 'Ritiro in studio' : 'A casa' } })
    }).catch(function () { /* solo un promemoria per il negozio */ });
  }

  function placeDelivery() {
    if (!delivery) return;
    var mobile = window.matchMedia('(max-width: 899px)').matches;
    var target = mobile ? document.querySelector('#tv2 .tv2-right') : $('tv2-bar');
    if (!target) return;
    if (mobile && delivery.parentElement !== target) target.appendChild(delivery);
    if (!mobile && delivery.parentElement !== target) target.insertBefore(delivery, target.firstChild);
  }

  all('[data-tv2-delivery]').forEach(function (button) {
    button.addEventListener('click', function () { setDelivery(button.dataset.tv2Delivery, true); });
  });
  try { if (sessionStorage.getItem('tv2-delivery') === 'pickup') state.delivery = 'pickup'; } catch (error) { /* facoltativo */ }

  function loadCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (cart && Number.isFinite(Number(cart.total_price))) {
          state.cartSubtotal = Number(cart.total_price) / 100;
          updateSummary();
        }
      })
      .catch(function () { /* senza carrello si calcola solo questa tela */ });
  }

  function updateCta() {
    if (!addButton) return;
    if (sampleMode) { addButton.hidden = true; return; }
    var label = addButton.querySelector('.add-to-cart-label');
    if (label && !addButton.disabled && addButton.getAttribute('aria-busy') !== 'true') label.textContent = 'Aggiungi al carrello';
  }

  /* ----------------------------------------------------- foto: miniatura e avvisi */

  function buildThumb() {
    var p = photo();
    if (!p || state.thumbReady) return;
    try {
      var max = 360;
      var ratio = Math.min(1, max / Math.max(p.w, p.h));
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(p.w * ratio));
      c.height = Math.max(1, Math.round(p.h * ratio));
      c.getContext('2d').drawImage(imgSource, 0, 0, c.width, c.height);
      app.style.setProperty('--tv2-thumb', 'url("' + c.toDataURL('image/jpeg', 0.82) + '")');
      state.thumbReady = true;
    } catch (error) {
      console.warn('[tela v2] miniatura', error);
    }
  }

  function updatePhotoInfo() {
    var p = photo();
    if (!p) return;
    $('tv2-photo-px').textContent = p.w + ' × ' + p.h + ' px' + (sampleMode ? ' · foto di esempio' : '');
    $('tv2-photo-name').textContent = sampleMode ? 'Foto di esempio' : 'La tua foto';
    // miniatura con le proporzioni della foto (verticale resta verticale)
    var thumb = document.querySelector('.tv2-photo-thumb');
    if (thumb && p.w && p.h) {
      var long = 60; var r = p.w / p.h;
      thumb.style.width = Math.round(r >= 1 ? long : Math.max(30, long * r)) + 'px';
      thumb.style.height = Math.round(r >= 1 ? Math.max(30, long / r) : long) + 'px';
    }
  }

  var placedOnce = false;
  function onPhotoPlaced() {
    loadRoomSoon();
    buildThumb();
    updatePhotoInfo();
    renderFormats();
    fitCanvas();
    syncZoomUi();
    updateDims();
    updateOrientationButtons();
    updateSummary();
    refreshPreviewViews();
    var c = engineCanvas();
    if (c) c.calcOffset();
    if (!placedOnce) {
      placedOnce = true;
      html.classList.add('tv2-ready');
    }
  }

  /* ------------------------------------------------------ caricamento della foto */

  function pickFile() {
    if (typeof window.loadImage === 'function') window.loadImage();
  }

  all('[data-tv2-upload]').forEach(function (button) { button.addEventListener('click', pickFile); });
  var pick = $('tv2-pick');
  if (pick) pick.addEventListener('click', function (event) { event.stopPropagation(); pickFile(); });

  var drop = $('tv2-drop');
  if (drop) {
    drop.addEventListener('click', pickFile);
    ['dragenter', 'dragover'].forEach(function (type) {
      drop.addEventListener(type, function (event) { event.preventDefault(); drop.classList.add('is-over'); });
    });
    ['dragleave', 'dragend'].forEach(function (type) {
      drop.addEventListener(type, function () { drop.classList.remove('is-over'); });
    });
    drop.addEventListener('drop', function (event) {
      event.preventDefault();
      drop.classList.remove('is-over');
      var file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
      if (!file || typeof window.handleChangeImage !== 'function') return;
      window.handleChangeImage({ target: { files: [file], value: '' } });
    });
  }

  /* ------------------------------------------ chat Ilaria: dalla testata compatta
     Il pulsante flottante è nascosto in questa pagina (CSS); "Chiedi a Ilaria" nella testata lo fa scattare.
     Il link compare solo quando la chat è attiva (stessa verifica del pulsante: attributo hidden). */
  function syncHelp() {
    var help = $('tv2-help');
    if (!help) return;
    var root = document.getElementById('tp-ilaria-root');
    var trigger = root && root.querySelector('.tp-il-prelaunch');
    help.hidden = !(root && !root.hidden && ((trigger && !trigger.hidden) || state.chatOpened));
  }
  function openChat() {
    var root = document.getElementById('tp-ilaria-root');
    if (!root) return;
    var trigger = root.querySelector('.tp-il-prelaunch');
    // dopo il primo clic il widget di Ilaria è caricato: si riapre dal suo pulsante
    var target = (trigger && !trigger.disabled && trigger) || root.querySelector('button:not(.tp-il-prelaunch)') || trigger;
    state.chatOpened = true;
    if (target) target.click();
  }

  /* ---------------------------------------------------------------- avvio */

  function measureBar() {
    var bar = $('tv2-bar');
    if (bar) html.style.setProperty('--tv2-bar-h', bar.offsetHeight + 'px');
  }

  // Registrato su window come quello del motore, quindi parte subito dopo di lui.
  window.addEventListener('DOMContentLoaded', function () {
    // Ricalcola la risoluzione del canvas sul nuovo spazio (il motore la misura sul vecchio layout nascosto).
    try {
      if (stage && stage.clientWidth > 0) {
        var mobile = window.matchMedia('(max-width: 899px)').matches;
        size = Math.round(clamp(Math.min(stage.clientWidth - (mobile ? 48 : 110), stage.clientHeight - (mobile ? 64 : 110)) * 1.6, 400, 900));
      }
    } catch (error) { /* il motore userà la sua misura */ }

    syncEffects();
    install3dDrag();
    installPinch();
    setDelivery(state.delivery, false);
    placeDelivery();
    updateEta();
    loadCart();
    measureBar();
    if (window.ResizeObserver && $('tv2-bar')) new ResizeObserver(measureBar).observe($('tv2-bar'));

    var s = engineSlider();
    if (s) s.addEventListener('input', function () { queueMicrotask(syncZoomUi); });

    var c = engineCanvas();
    if (c) {
      c.on('mouse:down', function () { html.classList.add('tv2-touched'); });
      c.on('after:render', scheduleEdge);
    }

    // Servizi e confezione regalo arrivano con fetch dal motore.
    var tbody = $('tbody-servizi');
    if (tbody) {
      new MutationObserver(renderServices).observe(tbody, { childList: true });
      renderServices();
    }
    var giftTries = 0;
    (function waitGift() {
      if (giftPrice() || giftTries > 40) { setupGift(); return; }
      giftTries += 1;
      setTimeout(waitGift, 250);
    })();

    var help = $('tv2-help');
    if (help) help.addEventListener('click', openChat);
    syncHelp();
    var chatRoot = document.getElementById('tp-ilaria-root');
    if (chatRoot) new MutationObserver(syncHelp).observe(chatRoot, { attributes: true, subtree: true, attributeFilter: ['hidden'] });

    var resizeFrame = 0;
    window.addEventListener('resize', function () {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(function () {
        placeDelivery();
        fitCanvas();
        measureBar();
        refreshPreviewViews();
        var cv = engineCanvas();
        if (cv) cv.calcOffset();
      });
    }, { passive: true });
    window.addEventListener('scroll', function () { var cv = engineCanvas(); if (cv) cv.calcOffset(); }, { passive: true });
    if (!html.classList.contains('tv2-unavailable')) html.classList.add('tv2-ready');
  });
})();
